
import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'


export default {
  getGroupProductSum(params) { // 获取企业分类产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getGroupProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getProductSum(params) { // 获取企业产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getDueProductSum(params) { // 获取过期产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getDueProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getUnusedProductSum(params) { // 获取闲置产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getUnusedProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getDueInMonthProductSum(params) { // 获取将过期产品总数
    const url =  baseURL + '/tbAuthorizedproduct/getDueInMonthProductSum';
    return axios.post(url, qs.stringify(params));
  },
  getCompanyUserPointList(params) { // 获取企业个人总排行榜
    const url =  baseURL + '/tbAuthorizedproduct/getCompanyUserPointList';
    return axios.post(url, qs.stringify(params));
  },
  getCompanyUserMonthPointList(params) { // 获取企业个人30天排行榜
    const url =  baseURL + '/tbAuthorizedproduct/getCompanyUserMonthPointList';
    return axios.post(url, qs.stringify(params));
  },
  
  getCompanyMonthPointBrokenLine(params) { // 获取企业30天折线图
    const url =  baseURL + '/tbAuthorizedproduct/getCompanyMonthPointBrokenLine';
    return axios.post(url, qs.stringify(params));
  },
  getUserMonthPointBrokenLine(params) { // 获取个人30天折线图
    const url =  baseURL + '/tbAuthorizedproduct/getUserMonthPointBrokenLine';
    return axios.post(url, qs.stringify(params));
  },
  getCompanyMonthModulePointPie(params) { // 获取企业30天模块饼图
    const url =  baseURL + '/tbAuthorizedproduct/getCompanyMonthModulePointPie';
    return axios.post(url, qs.stringify(params));
  },
  getCompanyUserMonthModulePointPie(params) { // 获取个人30天模块饼图
    const url =  baseURL + '/tbAuthorizedproduct/getCompanyUserMonthModulePointPie';
    return axios.post(url, qs.stringify(params));
  },
  
  
}



// WEBPACK FOOTER //
// ./src/api/statistics.js